<template>
  <div>
    <Form @submit="savePayInfo">
      <Divider content-position="left" label-width="4.4em">基本信息</Divider>
      <Field
        label="认证信息"
        v-model="orderData.userInfo"
        label-width="4.4em"
      />
      <Field label="手机号" v-model="orderData.phone" label-width="4.4em" />
      <Field label="用户ID" v-model="orderData.userId" label-width="4.4em" />
      <Field>
        <template #input>
          <Button
            size="small"
            type="success"
            color="#292827"
            round
            block
            native-type="submit"
            >保存基本信息</Button
          >
        </template>
      </Field>
    </Form>
  </div>
</template>
<script setup>
import { Button, Field, Divider, Form, Notify } from "vant";
import { useOrder } from "@/composables/useOrder";
const { orderData, saveOrder } = useOrder();
// 密码
let AuthorizationCode = sessionStorage.getItem("AuthorizationCode");
const savePayInfo = () => {
  const { userInfo, phone, userId } = orderData.value;
  saveOrder({ userInfo, phone, userId }, AuthorizationCode)
    .then((res) => {
      Notify({ type: "success", message: res });
    })
    .catch((res) => {
      Notify({ type: "warning", message: res });
    });
};
</script>
